// extracted by mini-css-extract-plugin
module.exports = {"slice":"d3Code__slice__2EAg2","main-arc":"d3Code__main-arc__2QrpL","hidden-arc":"d3Code__hidden-arc__3bOmv"};